import type { FieldProps } from 'formik'
import { Icon, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { Form } from 'react-bootstrap'
import type { ReactNode } from 'react'
import React from 'react'

type HelpBlockLayoutProps = { showError: boolean; formikField?: FieldProps; help?: string | ReactNode; meta?: any }
export const HelpBlockLayout = ({ meta, formikField, help, showError }: HelpBlockLayoutProps) => {
  meta = meta || formikField?.meta
  return (
    <>
      <ShowIf condition={help && !showError}>
        <Form.Text muted>{help}</Form.Text>
      </ShowIf>

      <ErrorBlockLayout showError={showError} meta={meta} formikField={formikField} />
    </>
  )
}

export const ErrorBlockLayout = ({ meta, formikField, showError }: HelpBlockLayoutProps) => {
  meta = meta || formikField?.meta

  return (
    <ShowIf condition={showError}>
      {/* text-danger-emphasis, not text-danger: Bootstrap emits `--bs-danger` and `--bs-danger-rgb`
          only inside its `:root`/`[data-bs-theme=light]` block (bootstrap5/scss/_root.scss:18,22),
          and `--bs-danger-text-emphasis` inside both that block and the dark one (:26, :156).
          Consuming apps differ on whether they restore `--bs-danger` under [data-bs-theme=dark],
          so this shared component takes the token every theme scopes. */}
      <Form.Text className="text-danger-emphasis">{meta?.error}</Form.Text>
    </ShowIf>
  )
}

type HelpTooltipProps = { help: string | ReactNode }
export const HelpTooltip = ({ help }: HelpTooltipProps) => {
  //exit if there is no help
  if (!help) return null

  return (
    <TooltipPopOver tooltipBody={help}>
      <Icon name="circle-question" />
    </TooltipPopOver>
  )
}
